import script from "./AppNotificationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNotificationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AppNotificationContainer.vue?vue&type=style&index=0&id=8ea90482&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ea90482"]])

export default __exports__